import {Injectable} from '@angular/core';
import {
  BaseComponentResolverServiceService
} from "../../../../../core/services/base-component-resolver-service.service";
import {
  ContractItemParcelStrategyComponent
} from "./contract-item-parcel-strategy/contract-item-parcel-strategy.component";
import {LegalCaseParcelStrategyComponent} from "./legal-case-parcel-strategy/legal-case-parcel-strategy.component";

@Injectable({
  providedIn: 'root'
})
export class ParcelCreateComponentResolverService extends BaseComponentResolverServiceService {

  constructor() {
    super({
      "CONTRACT_TERMINATION": LegalCaseParcelStrategyComponent,
      "OTHER": LegalCaseParcelStrategyComponent,
      "DEMAND_FOR_PAYMENT": LegalCaseParcelStrategyComponent,
      "BLOCKING_LETTER_CREATE": ContractItemParcelStrategyComponent,
      "DEMAND_FOR_RETURN": ContractItemParcelStrategyComponent,
      "RELEASING_LETTER_CREATE": ContractItemParcelStrategyComponent,
      "NO_CONTENT": LegalCaseParcelStrategyComponent,
      "DEFAULT": LegalCaseParcelStrategyComponent
    })
  }
}
